<div class="grid grid-cols-4 gap-4">
    <div class="col-span-4 flex justify-center items-center">
        <button mat-icon-button (click)="add()">
            <mat-icon>add</mat-icon>
        </button>

    </div>
    @for(enigma of enigmi; track $index){

    <div class="bg-white/10 flex flex-col rounded-3xl hover:scale-105 transition-spring-500ms">
        <div (click)="edit(enigma.id)" class="flex flex-col gap-2 p-4 hover:cursor-pointer">
            <p class="font-bold text-2xl text-primary-500">
                {{enigma.name}}
            </p>

            <!-- <app-card-summary-singleline size="sm" title="Id" [value]="mission.id" ></app-card-summary-singleline> -->
            <p class="w-full text-sm font-light">{{enigma.description}}</p>
            <app-card-summary-singleline title="Tipo" [value]="enigma.type ?? '0'"></app-card-summary-singleline>
        </div>

        <div class="flex justify-end items-center p-2">
            <button mat-icon-button style="color:red!important" [matMenuTriggerFor]="menu">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="icon icon-tabler icons-tabler-outline icon-tabler-trash">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M4 7l16 0" />
                    <path d="M10 11l0 6" />
                    <path d="M14 11l0 6" />
                    <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                    <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                </svg>
            </button>

            <mat-menu #menu="matMenu" backdropClass="bg-black/20">
            <div class="rounded-3xl bg-primary-950 p-4 flex flex-col gap-4">
                    <p class="text-primary-400">Vuoi procedere con l'eliminazione?</p>
                    <div class="flex justify-center items-center gap-2">
                        <button type="button" class="w-full bg-primary-500 text-black p-2 rounded-full">Annulla</button>
                        <button type="button" class="w-full bg-red-500 text-white p-2 rounded-full"
                            (click)="delete(enigma.id)">Elimina</button>
                    </div>
                </div>

            </mat-menu>
        </div>
    </div>
    }

    @if(enigmi.length == 0){
    <div class="col-span-4 flex justify-center items-center">
        <p>Nessun enigma trovato</p>
    </div>
    }
</div>